import { Platform, Text, View } from "@-/com.npmjs.react-native";
import { HANIVERSE_COMPOSITE_FONT_FAMILY } from "@-/dev.improve.haniverse.assets.graphemes.fonts/font-families";

const NAME = "Haniverse";
/** Spans 96% of the stage in Han Composite Black (sized to "Haniverse"). */
const NAME_FILL = 0.96;
/**
 * Advance width of "Haniverse" at weight 900. Drawn with RN `Text` so the composite font's
 * overlapping contours don't leave AA seams.
 */
const NAME_EM_WIDTH = 5.217;
/** Tight tracking for the wordmark. */
const ENGLISH_LETTER_SPACING_EM = -0.05;
const ENGLISH_LETTER_GAPS = NAME.length - 1;

/**
 * A wordmark in `color` (white over the dark galaxy, ink over the light one) spanning `width`
 * over the galaxy, in the app's own font.
 */
export function WelcomeGalaxyHeadline({
  color,
  height,
  width,
}: {
  color: string;
  height: number;
  width: number;
}) {
  const emWidth = NAME_EM_WIDTH + ENGLISH_LETTER_GAPS * ENGLISH_LETTER_SPACING_EM;
  const fontSize = width > 0 ? (width * NAME_FILL) / emWidth : 0;
  // Match the allocated box (`WELCOME_GALAXY_HEADLINE_ASPECT`) to keep the full glyphs visible.
  const lineHeight = height;
  const letterSpacing = fontSize * ENGLISH_LETTER_SPACING_EM;
  const textStyle = {
    fontFamily: HANIVERSE_COMPOSITE_FONT_FAMILY,
    fontSize,
    // Real wght axis — same as grapheme renderers; fontWeight alone is not enough on every path.
    fontVariationSettings: "'wght' 900",
    fontWeight: "900" as const,
    letterSpacing,
    lineHeight,
    textAlign: "center" as const,
    ...(Platform.OS === "android" ? { includeFontPadding: false } : null),
  };

  return (
    <View
      accessibilityLabel={NAME}
      accessibilityRole="header"
      accessible
      className="w-full justify-center"
      pointerEvents="none"
      style={{ height }}
      testID="auth-welcome-headline"
    >
      <Text
        allowFontScaling={false}
        style={[textStyle, { color }]}
        testID="auth-welcome-headline-name"
      >
        {NAME}
      </Text>
    </View>
  );
}
